/* import __COLOCATED_TEMPLATE__ from './cluster-list.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();